import { emptyFusionHubApi } from "src/common/service/fusionHub/emptyFusionHubApi";

export const exactOnlineApi = emptyFusionHubApi.injectEndpoints({
	endpoints: (builder) => ({
		getExactOnlineAuthorizationUrl: builder.query<
			{ authorizationUrl: string },
			{
				companyDomainId: string;
				redirectUrl: string;
			}
		>({
			query: ({ companyDomainId, redirectUrl }) => {
				const params = new URLSearchParams({
					redirectUrl,
					companyDomainId,
				});

				return {
					url: `/integrations/exact-online/proxy-authorize-url?${params.toString()}`,
				};
			},
		}),
		getExactOnlineReauthorizeUrl: builder.query<
			{ authorizationUrl: string },
			{
				integrationId: number;
				redirectUrl: string;
			}
		>({
			query: ({ integrationId, redirectUrl }) => {
				const params = new URLSearchParams({
					redirectUrl,
				});

				return {
					url: `/integrations/${integrationId}/exact-online-raw/proxy-re-authorization-url?${params.toString()}`,
					method: "GET",
				};
			},
		}),
	}),
	overrideExisting: "throw",
});

export const {
	useLazyGetExactOnlineAuthorizationUrlQuery,
	useLazyGetExactOnlineReauthorizeUrlQuery,
} = exactOnlineApi;
